const debounceMap: Record<string, {
  fn: ReturnType<typeof useDebounceFn>
  timeout: number
}> = {}

export default function useToasts() {
  const nuxtApp = useNuxtApp()
  const toast = useToast()

  const createToast = (params: {
    debounce?: number
    i18nParams?: { [key: string]: number | string }
    message: string
    status?: UToastType
  }) => {
    if (import.meta.client) {
      let color: 'green' | 'orange' | 'red' = 'green'
      let icon = getIcon('check')
      let title = (nuxtApp.$i18n as any).t(`toasts.${params.message}`, params.i18nParams || {})

      if (params.status === 'error') {
        color = 'red'
        icon = getIcon('error')
      }
      else if (params.status === 'warning') {
        color = 'orange'
        icon = getIcon('warning')
      }

      if (params.message.includes(' ')) {
        title = params.message
      }

      const sendToast = () => toast.add({
        color,
        icon,
        id: params.message.toLocaleLowerCase().replace(/ /g, '-'),
        title,
      })

      if (params.debounce) {
        if (debounceMap[params.message]?.timeout === params.debounce) {
          debounceMap[params.message].fn()

          return
        }

        debounceMap[params.message] = {
          fn: useDebounceFn(sendToast, params.debounce),
          timeout: params.debounce,
        }

        debounceMap[params.message].fn()

        return
      }

      sendToast()
    }
  }

  return { createToast }
}
